/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import yourCard from "../../Assets/youregift.png";
import qr from "../../Assets/qrcode.png";
import upright from "../../Assets/upright.png";

import { useDispatch } from "react-redux";
import { decryptAES } from "../../Common/Axios/encrypt";
import copyIcon from "../../Assets/copy.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  onGeOrderCodeReset,
  onGetOrderCode,
} from "../../Store/Slices/getOrderCodeSlice";
import {
  ApiRespCode,
  CardDataSlice,
  ClientInfo,
  GetImageUrl,
  GetOrderCodeReducer,
  OrderData,
  ParseInt,
  ThemeData,
  VendorData,
} from "../Utility/Utility";
import Loader from "../Loader/Loader";
import { handleVedorOrder } from "../OrderUtility/OrderUitlity";
import { onGetOrder, onGetOrderReset } from "../../Store/Slices/orderSlice";
import { useLocation } from "react-router-dom";
import { onPostVendorOrderReset } from "../../Store/Slices/vendorOrderSlice";

import { useRef } from "react";
import OrderAlternatePage from "../OrderConfirmation/orderAlternatePage";

const GiftcardSummary = () => {
  const dispatch = useDispatch();
  const cardData = CardDataSlice();
  const orderCodeData = GetOrderCodeReducer();
  const orderDetails = cardData;
  const location = useLocation();
  const clientInfo = ClientInfo();
  const vendorData = VendorData();
  const translation = getTranslationData();
  const orderData = OrderData();
  const themeData = ThemeData();
  const flow2 = clientInfo?.otpConfig === 2;
  const [loading, setLoading] = useState(false);
  const [showOrderFailed, setShowOrderFailed] = useState(false);
  const [showOrderProccess, setShowOrderProcess] = useState(false);
  const [orderDataUrl, setOrderDataUrl] = useState();
  const [showVendorOrderFailed, setVendorShowOrderFailed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [copiedCardIndex, setCopiedCardIndex] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState([]);
  const hasAutoExpanded = useRef(false);
  const selectedProductId = orderData?.updatedOrderData?.products?.[0]?.productId;
  const [openInst, setOpenInst] = useState(false);
  const [openRedeem, setOpenRedeem] = useState(false);
  const [openTermsCon, setOpenTermsCon] = useState(false);
  const productReducer = useSelector((state) => state.productReducer?.data);

  const selectedProduct = productReducer?.find(
    (item) => item?.id === selectedProductId
  );
  const giftCardData =
    orderCodeData?.OrderCodeData?.[0]?.giftCode &&
    decryptAES(orderCodeData?.OrderCodeData?.[0]?.giftCode);
  const orderMainData = orderCodeData?.OrderCodeData?.[0];

  const handleResize = () => {
    setIsMobile(window.innerWidth < 992);
  };
  useEffect(() => {
    flow2 && setLoading(true);
    dispatch(onGeOrderCodeReset());
    if (clientInfo?.otpConfig === 1) {
      dispatch(
        onGetOrderCode({
          id: orderDetails?.orderId,
          deno: orderDetails?.productData?.denomination,
        })
      );
    } else {
      if (!location?.state?.orderId) {
        const encData = window.location.search.slice(1);
        const decData = decryptAES(encData);
        const params = new URLSearchParams(decData);

        const orderId = params.get("orderId");
        const orderNumber = params.get("orderNumber");
        const denomination = params.get("denomination");
        setOrderDataUrl({
          orderId,
          orderNumber,
          denomination,
        });
        dispatch(onGetOrder({ id: orderId, isOrder: true }));
      } else {
        dispatch(onGetOrder({ id: location?.state?.orderId, isOrder: true }));
      }
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (flow2) {
      if (orderData?.status_code === ApiRespCode.v3Create) {
        if (
          orderData?.orderData?.orders?.[0]?.vendorOrderStatus?.toLowerCase() ===
          "COMPLETE".toLowerCase()
        ) {
          setLoading(false);
          setShowOrderFailed(false);
          dispatch(
            onGetOrderCode({
              id: location?.state?.orderId || orderDataUrl?.orderId,
              deno: location?.state?.denomination || orderDataUrl?.denomination,
            })
          );
        } else if (
          orderData?.orderData?.orders?.[0]?.vendorOrderStatus === "Pending"
        ) {
          const vendorPayload = {
            orderId: orderData?.orderData?.orders?.[0]?.orderNumber,
            supplierCode: orderData?.orderData?.orders?.[0]?.supplierCode,
            amount: orderData?.orderData?.orders?.[0]?.products?.reduce(
              (total, item) => total + item.denomination * item.qty,
              0
            ),
            products: orderData?.orderData?.orders?.[0]?.products?.map(
              ({ sku, denomination, qty }) => ({
                sku,
                denomination,
                qty,
              })
            ),
          };
          handleVedorOrder(dispatch, vendorPayload);
          setLoading(false);
        } else if (
          orderData?.orderData?.orders?.[0]?.orderStatus === "Failed"
        ) {
          setShowOrderFailed(true);
          setLoading(false);
        } else if (
          orderData?.orderData?.orders?.[0]?.vendorOrderStatus.toLowerCase() ===
          "Processing".toLowerCase()
        ) {
          setShowOrderProcess(true);
          setLoading(false);
        }
      }
    }
  }, [orderData]);

  useEffect(() => {
    if (vendorData?.post_status_code === ApiRespCode.create) {
      setLoading(false);
      setShowOrderProcess(false);
      dispatch(
        onGetOrderCode({
          id: location?.state?.orderId || orderDataUrl?.orderId,
          deno: location?.state?.denomination || orderDataUrl?.denomination,
        })
      );
      dispatch(onPostVendorOrderReset());
    } else if (
      vendorData?.post_status_code !== null &&
      !vendorData?.post_status_code === ApiRespCode.get
    ) {
      setShowOrderProcess(false);
      setShowOrderFailed(true);
      setLoading(false);
      setVendorShowOrderFailed(true);
      dispatch(onPostVendorOrderReset());
    } else if (
      vendorData?.post_status_code !== null &&
      vendorData?.post_status_code === ApiRespCode.get
    ) {
      setShowOrderProcess(true);
      setLoading(false);
      dispatch(onPostVendorOrderReset());
    }
  }, [vendorData]);

  useEffect(() => {
    if (!hasAutoExpanded.current && giftCardData?.length > 0) {
      setExpandedIndex(giftCardData.map((_, i) => i));
      hasAutoExpanded.current = true;
    }
  }, [giftCardData]);

  const toggleExpand = (index) => {
    expandedIndex.includes(index)
      ? setExpandedIndex(expandedIndex.filter((i) => i !== index))
      : setExpandedIndex([...expandedIndex, index]);
  };

  const handleCopy = (product, index) => {
    navigator.clipboard.writeText(product);
    setCopiedCardIndex(index);
    setTimeout(() => setCopiedCardIndex(null), 3000);
  };
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggle = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  return (
    <>
      {orderCodeData?.isGetLoading || vendorData?.isPostLoading || loading ? (
        <Loader />
      ) : (
        <div className="bg">
          <section className="mt-4 m-2">
            <div className="container p-2">
              <div className="row justify-content-center">
                <div className="col-lg-10 col-12">
                  <div className="bg-pink2">
                    <div
                      className={`p-2 ${
                        isMobile ? "" : "gift-header-container"
                      }`}
                    >
                      <div className="thankyoubox2">
                        <p className="onepgift gift-head-colr">
                          <img
                            src={
                              themeData?.imageUrl
                                ? GetImageUrl(themeData?.imageUrl)
                                : yourCard
                            }
                            alt="Your E-Gift Cards"
                          />{" "}
                          &nbsp;
                          {translation?.yourEGiftCards}
                        </p>
                      </div>
                      <div className="d-flex d-md-flex d-none">
                        <div className="ps-2">
                          <span className="text-muted font-sm order-num text-end">
                            {translation.orderNumber}
                          </span>
                          <span className="ps-2 gift-pri text-end">
                            {location?.state?.orderId
                              ? location?.state?.orderId
                              : orderDetails?.orderId
                              ? orderDetails?.orderId
                              : orderDataUrl?.orderId}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="m-2 mt-4">
            <div className="ps-2 d-md-none">
              <span className="text-muted font-sm order-num ">
                {translation?.orderNumber}
              </span>
              <span className="ps-2 gift-pri">
                {" "}
                {location?.state?.orderId
                  ? location?.state?.orderId
                  : orderDetails?.orderId
                  ? orderDetails?.orderId
                  : orderDataUrl?.orderId}
              </span>
            </div>

            <div className="container minhight p-2">
              <div className="row justify-content-center">
                {giftCardData &&
                  giftCardData?.map((product, index) => (
                    <div className="col-lg-5 col-12 mb-4" key={index}>
                      <div className="accordion" id="accordionExample">
                        <div className="its-card border-rad">
                          <h2
                            className="accordion-header"
                            id={`heading${index}`}
                          >
                            <button
                              className={`accordion-button d-flex align-items-center ${
                                openIndexes.includes(index) ? "collapsed" : ""
                              }`}
                              type="button"
                              aria-expanded={openIndexes.includes(index)}
                              aria-controls={`collapse${index}`}
                              onClick={() => toggle(index)}
                            >
                              {/* <i
                                className={`fas bot-icon ${expandedIndex.includes(index)
                                  ? "fa-chevron-down"
                                  : "fa-chevron-up"
                                  }`}
                              ></i> */}

                              <div className="d-flex justify-content-between align-items-center w-100 me-3">
                                <span className="gift-pri">
                                  {orderMainData?.name}
                                </span>
                                <span className="gift-pri pb-1">
                                  ₹{ParseInt(product?.Amount)}
                                </span>
                              </div>
                            </button>
                          </h2>

                          <div
                            className={`accordion-collapse collapse ${
                              openIndexes.includes(index) ? "" : "show"
                            }`}
                            id={`collapse${index}`}
                            aria-labelledby={`heading${index}`}
                          >
                            <div className="position-relative">
                              {copiedCardIndex === index && (
                                <span className="copy-message-overlay">
                                  {translation?.copiedSuccessfully}
                                </span>
                              )}
                              <div className="accordion-body">
                                <div className="d-flex justify-content-between">
                                  {product?.labels?.cardNumber.length > 0 && (
                                    <div className="copycode">
                                      <p className="codetitle">
                                        {product?.labels?.cardNumber}
                                      </p>
                                      <p className="giftcode1">
                                        {product?.CardNumber}
                                        &nbsp;
                                        <span
                                          onClick={() =>
                                            handleCopy(
                                              product?.CardNumber,
                                              index
                                            )
                                          }
                                        >
                                          <img
                                            src={copyIcon}
                                            alt={"copy-icon"}
                                            className="copy-icon"
                                          />
                                        </span>
                                      </p>
                                    </div>
                                  )}
                                  {product?.Barcode ? (
                                    <div className="qrcodeimg">
                                      <img
                                        className="qr-sz"
                                        src={qr}
                                        alt="QR Code"
                                      />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="d-flex justify-content-between mt-3 mb-3">
                                  {product?.CardPin?.length > 0 && (
                                    <div className="copycode">
                                      <p className="codetitle">
                                        {product?.labels?.cardPin}
                                      </p>
                                      <p className="giftcode">
                                        {product?.CardPin}&nbsp;
                                        <span
                                          onClick={() =>
                                            handleCopy(product?.CardPin, index)
                                          }
                                        >
                                          <img
                                            src={copyIcon}
                                            alt={"copy-icon"}
                                            className="copy-icon"
                                          />
                                        </span>
                                      </p>
                                    </div>
                                  )}
                                  <div
                                    className={`copycode txt-right ${
                                      product?.CardPin?.length ? "txt-dir" : ""
                                    }`}
                                  >
                                    <p className="codetitle">
                                      {translation?.expDate}
                                    </p>
                                    <p className="giftcode">
                                      {new Date(
                                        product?.Validity
                                      ).toLocaleDateString("en-GB")}
                                    </p>
                                  </div>
                                </div>
                                {product?.RedemptionUrl?.Url ? (
                                  <>
                                    {" "}
                                    <hr />
                                    <div
                                      className="d-flex justify-content-between"
                                      onClick={() =>
                                        window.open(
                                          product?.RedemptionUrl?.Url,
                                          "_blank"
                                        )
                                      }
                                    >
                                      <div className="copycode">
                                        <p className="gifttry">
                                          {translation?.visitNow} &nbsp;{" "}
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="none"
                                            stroke="var(--redeem-text-color)"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            viewBox="0 0 24 24"
                                          >
                                            <path d="M7 17L17 7M7 7h10v10" />
                                          </svg>
                                          {/* <img src={upright} alt="Try" /> */}
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="col-lg-10 col-12 justify-content-center mx-auto">
                <div className="text-center border-rad">
                  <div className="tnc_redeem_note_box jlkkedit2">
                    <div
                      className="item py-3"
                      onClick={() => setOpenInst(!openInst)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="text .jlkkedit2">
                        {translation?.importantInstructions}
                      </div>
                      <div className="arrow">
                        <i
                          className={`fa-solid ${
                            openInst ? "fa-angle-down" : "fa-angle-right"
                          }`}
                        ></i>
                      </div>
                    </div>
                    {openInst && (
                      <div
                        className="mt-2 mx-2 pd-left text-start"
                         style={{
            overflowWrap: "break-word",
          }}
                        dangerouslySetInnerHTML={{
                          __html: selectedProduct?.instructionsContent || "",
                        }}
                      ></div>
                    )}
                    <div
                      className="item py-3"
                      onClick={() => setOpenRedeem(!openRedeem)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="text">{translation?.how_to_use}</div>
                      <div
                        className="arrow"
                        onClick={() => setOpenRedeem(!openRedeem)}
                      >
                        <i
                          className={`fa-solid ${
                            openRedeem ? "fa-angle-down" : "fa-angle-right"
                          }`}
                        ></i>
                      </div>
                    </div>
                    {openRedeem && (
                      <div
                        className="mt-2 mx-2 pd-left text-start"
                        style={{
            overflowWrap: "break-word",
          }}
                        dangerouslySetInnerHTML={{
                          __html: selectedProduct?.howToUseContent || "",
                        }}
                      ></div>
                    )}
                    <div
                      className="item py-3"
                      onClick={() => setOpenTermsCon(!openTermsCon)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="text">{translation?.terms_condition}</div>
                      <div
                        className="arrow"
                        onClick={() => setOpenTermsCon(!openTermsCon)}
                      >
                        <i
                          className={`fa-solid ${
                            openTermsCon ? "fa-angle-down" : "fa-angle-right"
                          }`}
                        ></i>
                      </div>
                    </div>
                    {openTermsCon && (
                      <div
                        className="mt-2 mx-2 pd-left text-start"
                         style={{
            overflowWrap: "break-word",
          }}
                        dangerouslySetInnerHTML={{
                          __html: selectedProduct?.tncContent || "",
                        }}
                      ></div>
                    )}
                  </div>
                </div>
              </div>
              {(showOrderFailed || showVendorOrderFailed) && flow2 && (
                <section className="mt-4 m-2">
                  <div className="container p-2">
                    <div className="row justify-content-center">
                      <div className="col-lg-10 col-12">
                        <div className="bg-pink2">
                          <div
                            className={`p-2 ${
                              isMobile ? "" : "gift-header-container-center"
                            }`}
                          >
                            <div className="thankyoubox2">
                              <b>
                                {" "}
                                <i class="fa-solid fa-circle-exclamation"></i>{" "}
                                {showVendorOrderFailed &&
                                  translation.vendor_order_failed_orderdetails}
                                {showOrderFailed &&
                                  translation.order_failed_orderdetails}
                                {showOrderProccess &&
                                  translation.order_proccessing_message}
                              </b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
              {showOrderProccess && (
                <div className="row justify-content-center">
                  <OrderAlternatePage />
                </div>
              )}
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default GiftcardSummary;
